module.exports = __webpack_public_path__ + "img/logo.7246c80b.png";